<template>
  <div id="header-component" class="pt-4">
    <div class="d-flex align-items-stretch bg-black h-12-rem">
      <div
        id="header-logo-container"
        class="me-3 pe-2 pt-1 w-12">
        <img
          alt="Marlyse Photo"
          id="header-img-logo"
          class="ms-2 mb-2 clickable"
          @click="clickedHome"
          src="../assets/logo_mpp.png" />
      </div>
      <div
        v-if="!isUserConnected">
        <SignIn />
      </div>
      <div
        v-else>
        <ShowSignedIn />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import type { RouteLocationNormalizedLoaded, Router } from 'vue-router';

import SignIn from "@/components/SignIn.vue"; // @ is an alias to /src
import ShowSignedIn from "@/components/ShowSignedIn.vue"; // @ is an alias to /src

import { useUserStore } from "@/stores/user";
import { useCategoryStore } from "@/stores/category";

import { ROUTER_PATH_HOME } from "@/constants";

@Options({
  components: {
    SignIn,
    ShowSignedIn
  }
})
export default class Header extends Vue {
  userStore = useUserStore()
  categoryStore = useCategoryStore()

  $router!: Router;
  $route!: RouteLocationNormalizedLoaded;

  get isUserConnected() {
    return this.userStore.isConnected
  }

  public clickedHome() {
    console.log("clicked home")

    if (this.$router.currentRoute.value.path !== ROUTER_PATH_HOME) {
      this.$router.push({ path: '/', replace: true })
    }
  }
}
</script>

<style lang="stylus">
@media screen and (max-width: 480px) {
  #header-logo-container {
    max-width: 30%
  }
}

@media screen and (min-width: 481px) {
  #header-logo-container {
    max-width: 100%
  }
}

#header-img-logo {
  width: -webkit-fill-available;
}
</style>
